import { NameIdOption } from "../types/commonTypes";

export const SALARY_TYPE_OPTIONS: NameIdOption[] = [
  { id: "HOURLY", name: "hourlySalary" },
  { id: "MONTHLY", name: "monthlySalary" },
];
